var m = require('mithril');
var modal = require('../../layout/components/modal');
var tabs = require('../../components/tabs');
var smartChart = require('../../dashboards/components/smartChart');
var pointEvents = require('./pointEvents');
var pointCommands = require('./pointCommands');
var pointDocuments = require('./pointDocuments');
var pointHeaderPath = require('../pointHeaderPath');
var loaders = require('../../layout/components/loaders');

var latestOpenId = 0;

function pointName(column) {
  return column && (column.name || column.in && column.in.name) || 'Point';
}

function normalizedRid(record) {
  return record && record['@rid'] ? String(record['@rid']).replace(/^#/, '') : '';
}

function pointDetailLink(name, point, column) {
  var pointRid = normalizedRid(point);
  var columnRid = normalizedRid(column);
  var linkAttrs = {
    href: '/point/' + pointRid,
    class: 'point-detail-modal-link inline-flex items-center justify-center ml3 f4 ba bw1 dim',
    style: {
      width: '2.4rem',
      height: '1.8rem',
      padding: 0,
      lineHeight: '1'
    },
    title: 'Open point settings',
    'aria-label': 'Open point settings for ' + name,
    onclick: function () {
      modal.vm.close();
    }
  };

  if (columnRid) linkAttrs.params = { column: columnRid };

  return m(m.route.Link, linkAttrs, m('i.icon.ion-ios-gear.blue', {
    'aria-hidden': 'true',
    style: {
      display: 'block',
      'font-size': '1.5rem',
      lineHeight: '1'
    }
  }));
}

function setTitle(column) {
  modal.vm.title(
    m('span.point-trend-modal-path.flex.flex-wrap.items-baseline.w-100',
      pointHeaderPath.items(column, {
        onNavigate: function () {
          modal.vm.close();
        }
      }))
  );
}

function loadCanonicalColumn(column, openId) {
  var columnRid = normalizedRid(column);

  if (!columnRid) return;

  loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/column/' + columnRid,
    method: 'GET',
    background: true
  })
  .then(function (canonicalColumn) {
    if (openId !== latestOpenId || !canonicalColumn) return;

    setTitle(canonicalColumn);
    m.redraw();
  })
  .catch(function () {
    // Keep the title from the supplied column if the canonical path cannot load.
  });
}

function open(column) {
  var point = column && column.in;

  if (!point || !point['@rid']) return false;

  var openId = ++latestOpenId;
  var name = pointName(column);
  var chartElement = {
    name: name,
    chartSpan: 24,
    chartResample: 'hours',
    smartChartValueField: 'mean',
    hiddenFields: {}
  };

  setTitle(column);
  modal.vm.buttons([]);
  modal.vm.body = function () {
    return m('.point-trend-modal', [
      m('div.page-header.flex.justify-end.items-end', {
        key: 'point-detail-action',
        style: { borderBottomColor: '#777' }
      }, [
        pointDetailLink(name, point, column)
      ]),
      m(tabs, {
        key: 'point-history-tabs',
        tabs: {
          Graph: [smartChart, {
            key: point['@rid'],
            element: function () { return chartElement; },
            variant: 'pointBrowse',
            hideTitle: true,
            pointRecord: point,
            column: column
          }],
          Incidents: [pointEvents, {
            pointRecord: point,
            column: column,
            uri: 'Incidents'
          }],
          Commands: [pointCommands, {
            pointRid: point['@rid'],
            pageSize: 10,
            pointUnit: point.unit
          }],
          Documents: [pointDocuments, {
            pointRecord: point,
            column: column,
            uri: 'Documents'
          }]
        },
        options: {
          horizontal: true,
          default: 'Graph'
        }
      })
    ]);
  };
  modal.vm.open({ extrawidth: true });
  if (typeof modal.once === 'function') {
    modal.once('closed', function () {
      if (openId === latestOpenId) latestOpenId += 1;
    });
  }
  loadCanonicalColumn(column, openId);

  return true;
}

module.exports = {
  open: open
};
